import { z } from 'zod';

import { placeSchema } from './Place.ts';

export const roadmapSchema = z.object({
  message_type: z.literal('roadmap'),
  vehicle: z.string(),
  ride_id: z.number(),
  shift_id: z.number(),
  dispatch_provider_vehicle_id: z.number(),
  places: z.array(placeSchema),
});

export type RoadmapType = z.infer<typeof roadmapSchema>;
